import "./quick-base";
import "./service-now";
import "./salesforce";
import ProviderConfigConstant from "./provider-config.constant"

angular.module( "providers", [
  "providers.quickbase", "providers.servicenow", "providers.salesforce"
])
.constant("PROVIDERS", ProviderConfigConstant);
